'use client';

import cx from 'classnames';
import Image from 'next/image';
import { useIntl } from 'react-intl';

import { useTrackEventAmplitude } from '../../../../../../core/Tracking/Amplitude/Amplitude';
import { Button } from '../../../../../../design-system/components/form/button/Button';
import { imageUrlForStaticCdn } from '../../../../../../domains/Layout/Image/URL/ImageURL';
import { useUrlGenerator } from '../../../../../../shared/hooks/useUrlGenerator';

import style from './AgencyFooter.module.css';

export const AgencyFooter = () => {
    const { formatMessage } = useIntl();
    const { trackEvent } = useTrackEventAmplitude();
    const { generateBrandUrl } = useUrlGenerator();

    const conceptBrandPageUrl = generateBrandUrl('concept');

    const handleClickCta = () => {
        trackEvent((ampli, defaultProperties) => {
            ampli.betterTripClicked({
                ...defaultProperties,
                block: 'no_match',
                card_number: 1,
            });
        });
    };

    return (
        <footer className={cx(style.footer, style.footerNeutral)}>
            <Image
                fill
                src={imageUrlForStaticCdn(1768882, 2000, 447)}
                className={style.backgroundImage}
                alt=""
            />
            <div className={style.wrapper}>
                <div className={style.content}>
                    <div className={style.text}>
                        {/* eslint-disable-next-line local-rules/no-global-typography-classes -- ADR-0017: à migrer vers <Typography> */}
                        <h2 className={`font-secondary-s-regular ${style.heading}`}>
                            {formatMessage({ id: 'page.agency.footer.title' })}
                        </h2>
                        {/* eslint-disable-next-line local-rules/no-global-typography-classes -- ADR-0017: à migrer vers <Typography> */}
                        <p className="font-body-regular">
                            {formatMessage({ id: 'page.agency.footer.subtitle' })}
                        </p>
                        {conceptBrandPageUrl ? (
                            <div className={style.ctaWrapper}>
                                <Button
                                    priority="secondary"
                                    onClick={handleClickCta}
                                    href={conceptBrandPageUrl}
                                >
                                    {formatMessage({ id: 'page.agency.footer.cta' })}
                                </Button>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </footer>
    );
};
